import { useFaqCardForm } from "@/components/shared/forms/faq-card-form";
import type { FaqCard } from "@stackje/common/config";

interface EditFaqCardProps {
  card: FaqCard;
  cardIndex: number;
}

export function EditFaqCard({ card }: EditFaqCardProps) {
  const { formContent, previewContent, toggleType, shuffleColors, handleSubmit } = useFaqCardForm({
    initialData: {
      title: card.title || "",
      description: card.description || "",
      expandAll: card.expandAll || false,
      faqs: card.faqs.filter(faq =>
        faq.question && faq.question.trim() && faq.answer && faq.answer.trim()
      ).length > 0
        ? card.faqs.filter(faq =>
            faq.question && faq.question.trim() && faq.answer && faq.answer.trim()
          ).map(faq => ({
            question: faq.question!.trim(),
            answer: faq.answer!.trim(),
          }))
        : [{ question: "Sample question", answer: "Sample answer" }],
      type: card.type,
      colors: card.colors,
    },
    mode: "edit",
  });

  return {
    formContent,
    previewContent,
    toggleType,
    shuffleColors,
    handleSubmit,
  };
}
